export const AUTH_CALLBACK_PATH = '/auth/callback';
export const AUTH_ERROR_PATH = '/auth/error';
export function createAuthRedirect(config) {
    const { appEntryPath, fallbackOrigin, extraRedirectPaths = [] } = config;
    function getAppOrigin() {
        if (typeof window !== 'undefined' && window.location?.origin) {
            return window.location.origin;
        }
        if (fallbackOrigin)
            return fallbackOrigin.replace(/\/$/, '');
        return 'http://localhost:5173';
    }
    function getAuthCallbackUrl() {
        return `${getAppOrigin()}${AUTH_CALLBACK_PATH}`;
    }
    function getAppEntryUrl() {
        return `${getAppOrigin()}${appEntryPath}`;
    }
    function listSuggestedRedirectUrls(origin) {
        const base = (origin ?? getAppOrigin()).replace(/\/$/, '');
        return [
            `${base}${AUTH_CALLBACK_PATH}`,
            `${base}${AUTH_CALLBACK_PATH}/*`,
            `${base}${appEntryPath}`,
            `${base}/login`,
            `${base}/register`,
            `${base}/register/**`,
            `${base}/forgot-password`,
            `${base}/reset-password`,
            ...extraRedirectPaths.map((p) => (p.startsWith('/') ? `${base}${p}` : p)),
        ];
    }
    return {
        APP_ENTRY_PATH: appEntryPath,
        AUTH_CALLBACK_PATH,
        AUTH_ERROR_PATH,
        getAppOrigin,
        getAuthCallbackUrl,
        getAppEntryUrl,
        listSuggestedRedirectUrls,
    };
}
//# sourceMappingURL=redirect.js.map